import React, { useState, useEffect } from 'react';
// import '../dashboard/Dashboard.css'; // Import the CSS file for styles
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../dashboard/dailyactivity.css'; // Import the CSS file for styles


// Interfaces for Campaign
interface Campaign {
  id: number;
  campaign_name: string;
  video_impressions: number; // This will be used as BidRequests
  clicks: number; // This corresponds to Visits
  winRate: number;
  daily_cap: string;
  cost: string; // Used for CPC calculation
  startDate: string; // Added startDate
  visitors: number;
  cpc: number;
  adRequests: number;
  bidRequests: number;
  date: string;
}

const DailyActivityPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [campaignNames, setCampaignNames] = useState<string[]>([]); // Store campaign names
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [noData, setNoData] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>('Today');
  const [loading, setLoading] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState<string>('All Ads'); // New state for the dropdown filter


  // Function to calculate date ranges
  const calculateDateRange = (option: string) => {
    const today = new Date();
    let start: Date;
    let end: Date;

    switch (option) {
      case 'Today':
        start = new Date(today);
        end = new Date(today);
        break;
      case 'Yesterday':
        start = new Date(today);
        start.setDate(today.getDate() - 1);
        end = new Date(today);
        end.setDate(today.getDate() - 1);
        break;
      case 'Last 7 days':
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = new Date(today);
        break;
      case 'This Month':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today);
        break;
      case 'Last Month':
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'Last 30 days':
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = new Date(today);
        break;
      default:
        return;
    }

    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);
  };

  // Function to fetch campaign names from the server
  const fetchCampaignNames = async () => {
    try {
      const response = await fetch(`https://bidvertiser-api.vercel.app/api/campaigns/campaignNames`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setCampaignNames(data.campaignNames);
    } catch (error) {
      console.error('Error fetching campaign names:', error);
    }
  };

  // Fetch campaign names on component mount
  useEffect(() => {
    fetchCampaignNames();
  }, []);

  // Function to fetch data from the server
  const fetchData = async () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`https://bidvertiser-api.vercel.app/api/summary/getData?startDate=${startDate}&endDate=${endDate}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (data.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
        setCampaigns(data);
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle campaign filter selection
  const handleCampaignFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCampaign(event.target.value);
  };

  // Filter campaigns based on selected campaign name
  const filteredCampaigns = selectedCampaign === 'All Ads'
    ? campaigns
    : campaigns.filter((campaign) => campaign.campaign_name === selectedCampaign);

  const options = ['Today', 'Yesterday', 'Last 7 days', 'This Month', 'Last Month', 'Last 30 days'];

  return (
    <>
      {/* Top filter section */}
      <div className="">
        <div className="date-range">
          <select
            value={selectedOption}
            style={{
              gap: '0px'
            }}
            onChange={(e) => {
              setSelectedOption(e.target.value);
              calculateDateRange(e.target.value);
            }}
            className="date-picker"
          >
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <input
            type="date"
            className="date-picker"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <input
            type="date"
            className="date-picker"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          {/* Campaign filter dropdown */}
          <div className="campaign-filter" style={{ display: 'grid' }}>
            <label htmlFor="campaign-filter" style={{ marginTop: '-20px', fontSize: '12px' }}>Filter by Campaign:</label>
            <select
              id="campaign-filter"
              value={selectedCampaign}
              onChange={handleCampaignFilterChange}
              className="campaign-dropdown"
              style={{
                padding: '8px'
              }}
            >
              <option value="All Ads">All Ads</option>
              {campaignNames.map((name, index) => (
                <option key={index} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
          <button className="btn btn-generate" onClick={fetchData}>
            Generate
          </button>
        </div>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : noData ? (
        <div className="no-data-message">No data available for the selected date range.</div>
      ) : (
        <div
          className="campaign-table-container"
          
        >
          <table className="campaign-table-daily">
            <thead>
              <tr>
                <th>Date</th>
                <th>Bid Requests</th>
                <th>Visits</th>
                <th>Win Rate (%)</th>
                <th>Cost</th>
                <th>CPC</th>
                <th colSpan={3} style={{ textAlign: "center" }} >
                  <th className='dth'>
                  Conversion Details
                  </th>
                  
                  <div >
                    <tr>
                      <th style={{ width: '6.5%', borderBottom: '0px' }}>Conversions</th>
                      <th style={{ width: '10%', borderBottom: '0px'  }}>Rate</th>
                      <th style={{ width: '10%', borderBottom: '0px'  }}>Cost</th>
                    </tr>
                  </div>
                </th>
              </tr>

            </thead>
            <tbody>
              {filteredCampaigns.map((campaign) => {
                // Calculate Win Rate dynamically
                const winRate =
                  campaign.bidRequests > 0
                    ? ((campaign.visitors / campaign.bidRequests) * 100).toFixed(2)
                    : "0.00";

                return (
                  <tr key={campaign.id} className='dailyactivitydata'>
                    <td >{new Date(campaign.date).toLocaleDateString('en-US', { month: 'long', day: '2-digit', year: 'numeric' })}</td>
                    <td>{Intl.NumberFormat('en-US').format(Number(campaign.bidRequests))}</td>
                    <td>{Intl.NumberFormat('en-US').format(Number(campaign.visitors))}</td>
                    <td>{winRate}%</td> {/* Dynamically calculated */}
                    <td>${Number(campaign.cost)}</td>
                    <td>{campaign.cpc}</td>
                    <td>{ }</td>
                    <td>{ }</td>
                    <td>{ }</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}


    </>
  );
};

export default DailyActivityPage;



